module.exports = __webpack_public_path__ + "img/section2Icon3.b8d50d17.svg";